/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import { db } from "../../../firebase";

import usePagination from "../../helper/paginate/Pagination";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Swal from "sweetalert2";
import "../../../pages/dashboard/yoda.css";
import "./DataTableDemo.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation, Trans } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Col, Row, Modal, Checkbox } from "antd";
import axios from "axios";
import {
  Tag,
  Eye,
  Edit,
  Trash,
  MoreVertical,
  ChevronDown,
  ChevronUp,
  Sparkle,
} from "lucide-react";
import useIsDark from "../../../utils/isDark";
import { updateProduct } from "../../../redux/products/products";
import { fetchStore } from "../../../redux/store/store";

function SortableProductRow({ product, children, disabled }) {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: product.id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.55 : 1,
    position: "relative",
    zIndex: isDragging ? 20 : undefined,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={`border-b border-gray-200 dark:border-[#3c3a3d] transition-colors ${
        isDragging
          ? "bg-purple-50 dark:bg-[#2a2030] shadow-md ring-1 ring-[#9b59bf]/30"
          : "hover:bg-[#fcf6ff] dark:hover:bg-[#2a2a2a]"
      }`}
      {...attributes}
    >
      <td className="p-2 w-10 align-middle">
        <button
          type="button"
          className={`p-1.5 rounded-lg text-gray-400 hover:text-[#9b59bf] hover:bg-purple-50 dark:hover:bg-[#2a2a2a] touch-none ${
            disabled
              ? "opacity-30 cursor-not-allowed"
              : "cursor-grab active:cursor-grabbing"
          }`}
          aria-label={t("Products.Table.sort.dragHandle")}
          disabled={disabled}
          {...(disabled ? {} : listeners)}
        >
          <GripVertical size={16} />
        </button>
      </td>
      {children}
    </tr>
  );
}

const DataTableTemplatingDemo = ({
  setLgShow,
  setData,
  filter,
  pageSize,
  filteredProducts,
  allProducts,
  filter2,
}) => {
  // Get products from Redux or filteredProducts prop
  const products = useSelector((state) => {
    const allProducts = state.ProductsReducer || [];

    // Filter out deleted products and FoorAi landing pages (not product pages)
    let activeProducts = allProducts.filter(
      (product) =>
        product.deleted !== 1 &&
        product.created_via !== "FoorAiLandingPageGenerator",
    );

    // 🔴 طبق فلتر الحالة (out_of_stock, low_stock, hidden, ai_generated)
    if (filter2) {
      switch (filter2) {
        case "out_of_stock":
          activeProducts = activeProducts.filter((p) => p.qty <= 0);
          break;
        case "low_stock":
          activeProducts = activeProducts.filter(
            (p) => p.qty > 0 && p.qty <= p.limitedValue,
          );
          break;
        case "hidden":
          activeProducts = activeProducts.filter((p) => p.show === "0");
          break;
        case "ai_generated":
          activeProducts = activeProducts.filter(
            (p) => p.created_via === "FoorAiProductPageGenerator",
          );
          break;
        default:
          break;
      }
    }

    if (filter) {
      const searchTerm = filter.toLowerCase();
      return activeProducts.filter(
        (product) =>
          (product.name && product.name.toLowerCase().includes(searchTerm)) ||
          (product.sku && product.sku.toLowerCase().includes(searchTerm)),
      );
    }
    // Return all active products if no filter is applied
    return activeProducts;
  });

  const allProductsList = useSelector((state) => {
    const allProds = state.ProductsReducer || [];
    // Filter out deleted products and FoorAi landing pages
    return allProds.filter(
      (product) =>
        product.deleted !== 1 &&
        product.created_via !== "FoorAiLandingPageGenerator",
    );
  });
  const dispatch = useDispatch();

  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const [confirmers, setConfirmers] = useState([]);
  const [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const [expandedRows, setExpandedRows] = useState({});
  const [activeDragId, setActiveDragId] = useState(null);
  const [isAll, setIsAll] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [pendingRowData, setPendingRowData] = useState(null);
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const direction = currentLang === "ar" ? "rtl" : "ltr";
  const isDark = useIsDark();
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;

  // Add state to track which dropdown is open
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [isSendingAllToEcomanager, setIsSendingAllToEcomanager] =
    useState(false);
  const [sendingProductIds, setSendingProductIds] = useState(new Set());
  const darkModeStyles = `
  /* Mode sombre spécifique au tableau personnalisé */
  .dark table thead tr th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
  }

  .dark table tbody tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
  }

  .dark table tbody tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark table tbody tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark table tbody tr td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }
`;

  const orderKey =
    account?.productMode === "digital"
      ? "digitalProductsOrder"
      : "productsOrder";

  const orderedProducts = useMemo(() => {
    const list = products || [];
    const order = Array.isArray(store?.[orderKey]) ? store[orderKey] : [];
    if (!order.length) return list;

    const byId = new Map(list.map((p) => [p.id, p]));
    const ordered = [];

    order.forEach((id) => {
      const p = byId.get(id);
      if (p) {
        ordered.push(p);
        byId.delete(id);
      }
    });
    byId.forEach((p) => ordered.push(p));
    return ordered;
  }, [products, store, orderKey]);

  const count = Math.ceil(orderedProducts.length / PER_PAGE);
  const _DATA = usePagination(orderedProducts, PER_PAGE);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 6 },
    }),
  );

  const canReorder = !filter && !filter2;

  const handleDragStart = (event) => {
    setActiveDragId(event.active.id);
    setOpenDropdownId(null);
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    setActiveDragId(null);
    if (!over || active.id === over.id || !canReorder) return;

    const nextOrder = reorderProductIds(String(active.id), String(over.id));
    if (!nextOrder) return;
    await persistOrder(nextOrder);
  };

  const handleDragCancel = () => setActiveDragId(null);

  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = darkModeStyles;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const buildOrderList = (existingOrder, sourceList) => {
    const ids = (sourceList || []).map((p) => p.id).filter(Boolean);
    const normalizedOrder = Array.isArray(existingOrder)
      ? existingOrder.filter((id) => ids.includes(id))
      : [];

    ids.forEach((id) => {
      if (!normalizedOrder.includes(id)) {
        normalizedOrder.push(id);
      }
    });

    return normalizedOrder;
  };

  const persistOrder = async (nextOrder) => {
    if (!store?.id) return;
    try {
      await updateDoc(doc(db, "store", store.id), {
        [orderKey]: nextOrder,
      });
      dispatch(fetchStore({ ...store, [orderKey]: nextOrder }));
    } catch (error) {
      console.error("Error updating product order:", error);
    }
  };

  const reorderProductIds = (activeId, overId) => {
    const sourceList = allProductsList?.length ? allProductsList : products;
    const baseOrder = buildOrderList(store?.[orderKey], sourceList);
    const oldIndex = baseOrder.indexOf(activeId);
    const newIndex = baseOrder.indexOf(overId);
    if (oldIndex < 0 || newIndex < 0 || oldIndex === newIndex) return null;
    return arrayMove(baseOrder, oldIndex, newIndex);
  };

  useEffect(() => {
    if (!store?.id) return;
    const sourceList = allProductsList?.length ? allProductsList : products;
    if (!sourceList?.length) return;

    const nextOrder = buildOrderList(store?.[orderKey], sourceList);
    if (!nextOrder.length) return;

    const currentOrder = Array.isArray(store?.[orderKey])
      ? store[orderKey]
      : [];
    const isSameOrder =
      currentOrder.length === nextOrder.length &&
      currentOrder.every((id, index) => id === nextOrder[index]);

    if (isSameOrder) return;

    updateDoc(doc(db, "store", store.id), {
      [orderKey]: nextOrder,
    })
      .then(() => {
        dispatch(fetchStore({ ...store, [orderKey]: nextOrder }));
      })
      .catch((error) => {
        console.error("Error initializing product order:", error);
      });
  }, [store?.id, store?.[orderKey], orderKey, allProductsList, products]);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  // Toggle row expansion
  const toggleRow = (productId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  useEffect(() => {
    const fetchConfirmersAndInvitations = async () => {
      if (!(account && account.user)) {
        setConfirmers([]);
        return;
      }

      try {
        const confirmersQuery = query(
          collection(db, "confirmers"),
          where("addedBy", "==", account.user),
        );

        const invitationsQuery = query(
          collection(db, "invitations"),
          where("status", "==", 2),
          where("shopUser", "==", account.user),
        );

        const [confirmersSnapshot, invitationsSnapshot] = await Promise.all([
          getDocs(confirmersQuery),
          getDocs(invitationsQuery),
        ]);

        const confirmersList = confirmersSnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));

        const confirmUserIds = [
          ...new Set(
            invitationsSnapshot.docs
              .map((doc) => doc.data()?.confirmUser)
              .filter(Boolean),
          ),
        ];

        let invitationConfirmers = [];
        if (confirmUserIds.length > 0) {
          const batches = [];
          for (let i = 0; i < confirmUserIds.length; i += 10) {
            batches.push(confirmUserIds.slice(i, i + 10));
          }

          const inviterSnapshots = await Promise.all(
            batches.map((batch) =>
              getDocs(
                query(collection(db, "confirmers"), where("user", "in", batch)),
              ),
            ),
          );

          invitationConfirmers = inviterSnapshots.flatMap((snapshot) =>
            snapshot.docs.map((item) => ({
              ...item.data(),
              id: item.id,
            })),
          );
        }

        const mergedConfirmers = new Map();
        [...confirmersList, ...invitationConfirmers].forEach((item) => {
          mergedConfirmers.set(item.id || item.user, item);
        });

        setConfirmers(Array.from(mergedConfirmers.values()));
      } catch (error) {
        console.error("Error fetching confirmers/invitations:", error);
      }
    };

    fetchConfirmersAndInvitations();
  }, [account?.user]);

  const changepaid = async (data, status) => {
    const nextProduct = { ...data, show: status };
    await setDoc(doc(db, "products", data.id), nextProduct);
    dispatch(updateProduct(nextProduct));
  };

  const message = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        showCancelButton: true,
        title: (
          <Trans
            i18nKey="Products.Table.freeTrial.title"
            components={{
              a: (
                <a
                  href="https://m.me/F0orweb"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        ),
        confirmButtonText: t("common.yes"),
        cancelButtonText: t("common.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  const truncateName = (name, maxLength = 20) => {
    return name.length > maxLength
      ? name.substring(0, maxLength) + "..."
      : name;
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("Products.Table.delete.confirmTitle"),
      text: t("Products.Table.delete.confirmText"),
      confirmButtonText: t("common.yes"),
      cancelButtonText: t("common.no"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // تحديث deleted: 1 يعني أنه تم الحذف
          const nextProduct = { ...data, deleted: 1 };
          await setDoc(doc(db, "products", data.id), nextProduct);
          dispatch(updateProduct(nextProduct));

          Swal.fire({
            icon: "success",
            title: t("Products.Table.delete.successTitle"),
            text: t("Products.Table.delete.successText"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
            position: "bottom-end",
            toast: true,
          });
        } catch (error) {
          console.error("Error deleting product:", error);
          Swal.fire({
            icon: "error",
            title: t("common.error"),
            text: t("Products.Table.delete.errorText"),
            confirmButtonColor: "#7e5395",
          });
        }
      }
    });
  };

  const handleUpdate = async (rowData) => {
    setData(rowData);
    setLgShow(true);
  };

  const isEcomanagerRequestSuccessful = (response) => {
    if (!response || response.status < 200 || response.status >= 300) {
      return false;
    }

    const payload = response.data;

    if (!payload || typeof payload !== "object") {
      return true;
    }

    if (typeof payload.success === "boolean") return payload.success;
    if (typeof payload.ok === "boolean") return payload.ok;
    if (typeof payload.status === "boolean") return payload.status;

    if (typeof payload.status === "string") {
      const normalized = payload.status.toLowerCase();
      if (["success", "ok", "created", "done"].includes(normalized)) {
        return true;
      }
      if (["error", "failed", "fail"].includes(normalized)) {
        return false;
      }
    }

    if (payload.error || payload.errors) {
      return false;
    }

    return true;
  };

  const getEcomanagerFailureMessage = (payload) => {
    if (!payload || typeof payload !== "object") return null;

    if (typeof payload.message === "string" && payload.message.trim()) {
      return payload.message;
    }

    if (typeof payload.error === "string" && payload.error.trim()) {
      return payload.error;
    }

    if (Array.isArray(payload.errors) && payload.errors.length > 0) {
      const firstError = payload.errors[0];
      if (typeof firstError === "string") return firstError;
      if (firstError && typeof firstError.message === "string") {
        return firstError.message;
      }
    }

    return null;
  };

  const getEcomanagerErrorMessage = (error) => {
    const payload = error?.response?.data;

    if (!payload) {
      return error?.message || null;
    }

    const directMessage = getEcomanagerFailureMessage(payload);
    if (directMessage) {
      return directMessage;
    }

    if (payload?.errors && typeof payload.errors === "object") {
      const errorValues = Object.values(payload.errors).flat();
      const firstValue = errorValues.find(Boolean);
      if (typeof firstValue === "string") return firstValue;
      if (firstValue && typeof firstValue.message === "string") {
        return firstValue.message;
      }
    }

    return error?.message || null;
  };

  const handleEcomanager = async (products) => {
    const urlEcomanager = `${store.Secomanager}products`;
    try {
      const response = await axios.post(
        urlEcomanager,
        {
          title: products?.name,
          sku: products?.sku,
          price: parseInt(products?.price),
          is_active: true,
          open_stock: true,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${store.ecomanager}`,
          },
        },
      );

      if (!isEcomanagerRequestSuccessful(response)) {
        throw new Error(
          getEcomanagerFailureMessage(response?.data) ||
            "Ecomanager request was not accepted",
        );
      }

      if (products?.id) {
        await updateDoc(doc(db, "products", products.id), {
          ecommanageractive: true,
        });
        dispatch(updateProduct({ ...products, ecommanageractive: true }));
      }

      return response.data;
    } catch (error) {
      console.error("حدث خطأ:", error);
      throw error;
    }
  };

  const handleSendAllToEcomanager = async () => {
    const sourceList = allProductsList?.length ? allProductsList : products;
    const productsToSend = (sourceList || []).filter(
      (product) => !product?.ecommanageractive,
    );

    if (!productsToSend.length) {
      Swal.fire({
        icon: "info",
        title: t("Products.Table.ecomanager.noProducts"),
        text: t("Products.Table.ecomanager.noProductsText"),
        confirmButtonColor: "#7e5395",
      });
      return;
    }

    const confirmResult = await Swal.fire({
      title: t("Products.Table.ecomanager.confirmTitle"),
      text: t("Products.Table.ecomanager.confirmText", {
        count: productsToSend.length,
      }),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("Products.Table.ecomanager.confirmButton"),
      cancelButtonText: t("Products.Table.ecomanager.cancelButton"),
      confirmButtonColor: "#7e5395",
      cancelButtonColor: "#e87778",
    });

    if (!confirmResult.isConfirmed) return;

    setIsSendingAllToEcomanager(true);

    let successCount = 0;
    let failCount = 0;
    const failMessages = [];
    const total = productsToSend.length;

    // Afficher la progression
    Swal.fire({
      title: t("Products.Table.ecomanager.progressTitle", {
        current: 0,
        total,
      }),
      html: `<div style="width:100%;background:#eee;border-radius:8px;overflow:hidden;height:18px;margin-top:10px;"><div id="eco-progress-bar" style="width:0%;height:100%;background:#7e5395;transition:width 0.3s;border-radius:8px;"></div></div><p id="eco-progress-text" style="margin-top:8px;font-size:13px;color:#888;">${t("Products.Table.ecomanager.progressText")}</p>`,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      for (let i = 0; i < total; i++) {
        try {
          await handleEcomanager(productsToSend[i]);
          successCount++;
        } catch (error) {
          failCount++;
          const errorMessage = getEcomanagerErrorMessage(error);
          if (errorMessage) {
            failMessages.push(errorMessage);
          }
        }

        // Mettre à jour la progression
        const progress = Math.round(((i + 1) / total) * 100);
        const progressBar = document.getElementById("eco-progress-bar");
        const progressText = document.getElementById("eco-progress-text");
        if (progressBar) progressBar.style.width = `${progress}%`;
        if (progressText) progressText.textContent = `${i + 1} / ${total}`;
        Swal.update({
          title: t("Products.Table.ecomanager.progressTitle", {
            current: i + 1,
            total,
          }),
        });
      }

      await Swal.fire({
        icon: failCount > 0 ? "warning" : "success",
        title:
          failCount > 0
            ? t("Products.Table.ecomanager.partialSuccess")
            : t("Products.Table.ecomanager.fullSuccess"),
        text:
          failCount > 0
            ? t("Products.Table.ecomanager.partialSuccessText", {
                success: successCount,
                fail: failCount,
              })
            : t("Products.Table.ecomanager.fullSuccessText", {
                success: successCount,
              }),
        footer:
          failCount > 0 && failMessages.length > 0
            ? failMessages[0]
            : undefined,
        confirmButtonColor: "#7e5395",
      });
    } finally {
      setIsSendingAllToEcomanager(false);
    }
  };

  const getProductSendKey = (product) => product?.id || product?.sku;

  const handleSendProductToEcomanager = async (product) => {
    const productKey = getProductSendKey(product);
    if (!productKey) return;

    if (product?.ecommanageractive) {
      Swal.fire({
        icon: "info",
        title: t("Products.Table.ecomanager.alreadySentTitle"),
        text: t("Products.Table.ecomanager.alreadySentText", {
          name: product?.name || t("Products.Table.headers.product"),
        }),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    setSendingProductIds((prev) => {
      const next = new Set(prev);
      next.add(productKey);
      return next;
    });

    try {
      await handleEcomanager(product);
      await Swal.fire({
        icon: "success",
        title: t("Products.Table.ecomanager.productSent"),
        text: t("Products.Table.ecomanager.productSentText"),
        timer: 1800,
        timerProgressBar: true,
        showConfirmButton: false,
        position: "bottom-end",
        toast: true,
      });
    } catch (error) {
      const errorMessage = getEcomanagerErrorMessage(error);
      await Swal.fire({
        icon: "error",
        title: t("Products.Table.ecomanager.productFailed"),
        text: errorMessage || t("Products.Table.ecomanager.productFailedText"),
        confirmButtonColor: "#7e5395",
      });
    } finally {
      setSendingProductIds((prev) => {
        const next = new Set(prev);
        next.delete(productKey);
        return next;
      });
    }
  };

  const handleVerifyCode = async () => {
    if (verificationCode.length === 6) {
      try {
        const res = await fetch(
          "https://backend-digital.foorweb.store/api/verifyOtpGoogle",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code: verificationCode,
              user: account?.user,
            }),
          },
        );

        const data = await res.json();

        if (data.success) {
          const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
          let token = "";
          const length = 32;
          for (let i = 0; i < length; i++) {
            token += chars.charAt(Math.floor(Math.random() * chars.length));
          }

          // حفظ الـ token في localStorage
          localStorage.setItem("otpToken", token);

          // حفظ الـ token والوقت الحالي في Firestore
          const secretRef = doc(db, "secretKeys", account?.user);
          await updateDoc(secretRef, {
            token: token,
            lastUsed: Date.now(), // حفظ الوقت الحالي بالمللي ثانية
          });

          setShowOtpModal(false);
          setVerificationCode("");

          if (pendingRowData) {
            handleUpdate(pendingRowData);
            setPendingRowData(null);
          }
        } else {
          Swal.fire({
            icon: "error",
            title: t("Products.Table.otp.wrongCode"),
            confirmButtonText: t("common.ok"),
            confirmButtonColor: "#7e5395",
            timer: 3000,
            timerProgressBar: true,
            position: "bottom-end",
            toast: true,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("Error verifying code:", error);
      }
    }
  };

  const paidBodyTemplate = (rowData) => {
    const color = rowData.show === "1" ? "#12b669" : "#474747";

    return (
      <>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{t("Products.Table.status.tooltip")}</Tooltip>}
        >
          <div className="relative inline-block w-11 h-5">
            <input
              aria-label={t("Products.Table.status.ariaLabel")}
              id={`switch-${rowData.id}`}
              type="checkbox"
              checked={rowData.show === "1"}
              onChange={
                !!account.store
                  ? (e) => {
                      changepaid(rowData, e.target.checked ? "1" : "0");
                    }
                  : () => {
                      message();
                    }
              }
              className="peer appearance-none w-11 h-5 bg-[#232323] border border-slate-300 rounded-full checked:bg-[#12b669] checked:border-slate-800 cursor-pointer transition-colors duration-300"
            />
            <label
              htmlFor={`switch-${rowData.id}`}
              className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full border border-slate-300 shadow transition-transform duration-300 peer-checked:translate-x-6 peer-checked:border-slate-800 cursor-pointer"
            ></label>
          </div>
        </OverlayTrigger>
      </>
    );
  };

  const isOtpExpired = async () => {
    const tokenOtp = localStorage.getItem("otpToken");
    if (!tokenOtp) return true;

    try {
      // الحصول على بيانات المفتاح السري من Firestore
      const secretRef = doc(db, "secretKeys", account?.user);
      const secretDoc = await getDoc(secretRef);

      if (!secretDoc.exists()) {
        return true; // إذا لم يكن هناك مستند، فالـ OTP منتهي الصلاحية
      }

      const secretData = secretDoc.data();
      const storedToken = secretData.token;
      const lastUsed = secretData.lastUsed;

      // التحقق من أن الـ token متطابق
      if (storedToken !== tokenOtp) {
        return true;
      }

      // التحقق من أن الـ token لم يتجاوز 30 دقيقة (30 * 60 * 1000 = 1800000 مللي ثانية)
      const currentTime = Date.now();
      const timeDifference = currentTime - lastUsed;
      const thirtyMinutesInMs = 30 * 60 * 1000;

      if (timeDifference > thirtyMinutesInMs) {
        // إزالة الـ token من localStorage لأنه منتهي الصلاحية
        localStorage.removeItem("otpToken");
        return true;
      }

      return false; // الـ token صالح
    } catch (error) {
      console.error("Error checking OTP expiration:", error);
      return true; // في حالة الخطأ، نعتبر الـ token منتهي الصلاحية
    }
  };

  const CombinedTemplate = ({ rowData, confirmers, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState(new Set());
    const buttonImage = "/logo-min 2.png";
    const togglePopup = () => {
      setIsOpen(!isOpen);
    };

    const closePopup = () => {
      setIsOpen(false);
    };

    const toggleProductStatus = async (checked) => {
      const newStatus = checked;
      setIsAll(newStatus);
      const nextProduct = {
        ...rowData,
        isAll: newStatus,
      };
      await setDoc(doc(db, "products", rowData.id), nextProduct);
      dispatch(updateProduct(nextProduct));
    };

    const setUptoDelivery = async (checked) => {
      const newStatus1 = checked;
      setIsAll(newStatus1);
      const nextProduct = {
        ...rowData,
        upToDelivery: newStatus1,
      };
      await setDoc(doc(db, "products", rowData.id), nextProduct);
      dispatch(updateProduct(nextProduct));
    };

    const setEditOrders = async (checked) => {
      const newStatus2 = checked;
      setIsAll(newStatus2);
      const nextProduct = {
        ...rowData,
        editToOrders: newStatus2,
      };
      await setDoc(doc(db, "products", rowData.id), nextProduct);
      dispatch(updateProduct(nextProduct));
    };

    const handleAddProduct = async () => {
      if (selectedUsers.size === 0) {
        Swal.fire({
          title: t("common.error"),
          text: t("Products.Table.confirmers.selectUserError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
        return;
      }

      try {
        const newProductData = {
          active: true,
          beginDate: new Date(),
          endDate: null,
          shopName: account.name,
          shopUser: account.user,
          sku: [`${rowData.sku}`],
          storeImage: account.image,
        };
        //* do Api for rules
        const q = query(
          collection(db, "confirmers"),
          where("user", "in", Array.from(selectedUsers)),
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          Swal.fire({
            title: t("Products.Table.confirmers.warning"),
            text: t("Products.Table.confirmers.userNotFound"),
            icon: "warning",
            confirmButtonText: t("common.ok"),
          });
          return;
        }

        const updates = querySnapshot.docs.map(async (doc) => {
          const data = doc.data();
          const existingProductIndex = data.products.findIndex(
            (product) => product.shopUser === account.user,
          );

          if (existingProductIndex !== -1) {
            const existingProduct = data.products[existingProductIndex];
            const skuIndex = existingProduct.sku.indexOf(rowData.sku);

            if (skuIndex !== -1) {
              // Remove the SKU if it exists
              existingProduct.sku.splice(skuIndex, 1);
              await updateDoc(doc.ref, { products: data.products });
            } else {
              // If 'all' is found, replace it with the new SKU
              const allIndex = existingProduct.sku.indexOf("all");
              if (allIndex !== -1) {
                existingProduct.sku[allIndex] = rowData.sku;
              } else {
                existingProduct.sku.push(rowData.sku);
              }
              await updateDoc(doc.ref, { products: data.products });
            }
          } else {
            // Add the new product
            await updateDoc(doc.ref, {
              products: arrayUnion(newProductData),
            });
          }
        });

        await Promise.all(updates);

        const result = await Swal.fire({
          title: t("Products.Table.confirmers.success"),
          icon: "success",
          confirmButtonText: t("common.ok"),
        });

        if (result.isConfirmed) {
          console.log("تم اختيار التاريخ:", result.value);
        }

        if (result.isConfirmed) {
          closePopup();
        }
      } catch (error) {
        console.error("Error adding/removing product: ", error);
        Swal.fire({
          title: t("common.error"),
          text: error.message || t("Products.Table.confirmers.addRemoveError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
      }
    };

    const handleDelete = async (userId) => {
      // تأكيد المستخدم قبل الحذف
      const result = await Swal.fire({
        title: t("Products.Table.confirmers.deleteConfirmTitle"),
        text: t("Products.Table.confirmers.deleteConfirmText"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("Products.Table.confirmers.deleteConfirmBtn"),
        cancelButtonText: t("Products.Table.confirmers.deleteCancelBtn"),
      });

      if (!result.isConfirmed) {
        // إذا لم يؤكد المستخدم، لا تنفذ عملية الحذف
        return;
      }

      try {
        const q = query(
          collection(db, "confirmers"),
          where("addedBy", "==", account.user),
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          Swal.fire({
            title: t("Products.Table.confirmers.warning"),
            text: t("Products.Table.confirmers.userNotFound"),
            icon: "warning",
            confirmButtonText: t("common.ok"),
          });
          return;
        }

        const updates = querySnapshot.docs.map(async (doc) => {
          const data = doc.data();
          const productIndex = data.products.findIndex(
            (product) => product.shopUser === account.user,
          );

          if (productIndex !== -1) {
            let updatedProducts = [...data.products];
            const product = updatedProducts[productIndex];
            const skuIndex = product.sku.indexOf(rowData.sku);

            if (skuIndex !== -1) {
              product.sku.splice(skuIndex, 1);

              if (product.sku.length === 0) {
                // Replace with 'all' if SKU list is empty
                product.sku.push("all");
              }
            }

            // Update the product in Firestore
            await updateDoc(doc.ref, { products: updatedProducts });
          }
        });

        await Promise.all(updates);

        Swal.fire({
          title: t("Products.Table.confirmers.success"),
          text: t("Products.Table.confirmers.removeSuccess"),
          icon: "success",
          confirmButtonText: t("common.ok"),
        });
      } catch (error) {
        console.error("Error deleting product: ", error);
        Swal.fire({
          title: t("common.error"),
          text: error.message || t("Products.Table.confirmers.deleteError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
      }
    };

    const handleCheckboxChange = (user, isChecked) => {
      const updatedSelectedUsers = new Set(selectedUsers);
      if (isChecked) {
        updatedSelectedUsers.add(user);
      } else {
        updatedSelectedUsers.delete(user);
      }
      setSelectedUsers(updatedSelectedUsers);
    };

    // حالة كل مفتاح تبديل
    const [systemNotification, setSystemNotification] = useState(true);
    const [salesAndNews, setSalesAndNews] = useState(false);
    const [accountTips, setAccountTips] = useState(true);

    return (
      <div className="relative">
        <button
          className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] dark:!border-[#3c3a3d] dark:!bg-[#181919] transition-colors active:bg-[#faf1ff] bot mx-auto"
          onClick={togglePopup}
        >
          <img src={buttonImage} style={{ width: "20px" }} alt={t("ui.buttonIcon")} />
        </button>

        <Modal
          visible={isOpen}
          onCancel={closePopup}
          footer={null}
          width="25%"
          destroyOnClose
          wrapClassName={isDark ? "dark-modal" : ""}
        >
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-[#3c3a3d] dark:bg-[#181919]">
            <h2 className="text-lg font-medium text-gray-800 dark:text-gray-200">
              {t("Products.Table.confirmers.modalTitle")}
            </h2>
          </div>

          <div className="dark:bg-[#181919]">
            <div className="max-w-5xl mx-auto px-4 mt-2 md:px-8 dark:bg-[#181919]">
              <div className="flex justify-between p-4 rounded-md bg-blue-50 border border-blue-300 dark:!bg-[#1e1e1e] dark:border-[#3c3a3d]">
                <div className="flex gap-3">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-500 dark:text-blue-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div className="self-center">
                    <span className="text-blue-600 dark:text-blue-400 font-medium">
                      {t("Products.Table.confirmers.noticeTitle")}
                    </span>
                    <div className="text-blue-600 dark:text-blue-400">
                      <p className="mt-2 sm:text-sm">
                        {t("Products.Table.confirmers.noticeText")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul className="grid gap-y-2 gap-x-6 flex-wrap mt-3 overflow-y-auto">
              {confirmers.map((confirmer, idx) => {
                const isSkuInConfirmer = confirmer.products?.some(
                  (product) =>
                    Array.isArray(product.sku) &&
                    product.sku.some((sku) => sku === rowData.sku),
                );
                const isChecked = isSkuInConfirmer;

                return (
                  confirmer.deleted !== true &&
                  isChecked && (
                    <div
                      className="ant-col ant-col-24 hp-border-radius-lx hp-border-1 border border-gray-200 dark:border-[#3c3a3d] dark:bg-[#1e1e1e]"
                      style={{
                        paddingLeft: "6px",
                        paddingRight: "6px",
                        position: "relative",
                      }}
                      key={idx}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/9427/9427108.png"
                        style={{ zIndex: 10, width: "22px" }}
                        onClick={() => handleDelete(confirmer.user)}
                        className="absolute top-0 left-0 cursor-pointer"
                      />

                      <div
                        className="ant-row ant-row-space-between ant-row-middle"
                        style={{ rowGap: "0px" }}
                      >
                        <div className="ant-col ant-col-24 hp-mb-sm-16 ant-col-sm-12">
                          <div
                            className="ant-row ant-row-no-wrap ant-row-middle"
                            style={{ rowGap: "0px" }}
                          >
                            <Checkbox
                              id={`confirmer-${idx}`}
                              type="checkbox"
                              className="checkbox-item peer hidden"
                              onChange={(e) =>
                                handleCheckboxChange(
                                  confirmer.user,
                                  e.target.checked,
                                )
                              }
                              checked
                              disabled
                            />

                            <div className="ant-col">
                              <div
                                className="hp-border-radius-md hp-cursor-pointer hp-border-1 hp-mr-16 m-2 rounded-full border-gray-300 dark:border-[#3c3a3d]"
                                style={{
                                  maxHeight: "64px",
                                  maxWidth: "64px",
                                }}
                              >
                                <div className="hp-border-radius-in hp-overflow-hidden hp-m-4 hp-d-flex rounded-full">
                                  <img
                                    src={
                                      confirmer.image ||
                                      "https://randomuser.me/api/portraits/women/79.jpg"
                                    }
                                    alt={t("workersManagement.table.user")}
                                    style={{ height: "100%" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ant-col">
                              <span className="hp-d-block hp-p3-body hp-font-weight-700 text-gray-800 dark:text-gray-200">
                                {confirmer.name}
                              </span>
                              <span
                                className="hp-d-block hp-p1-body text-gray-700 dark:text-gray-400"
                                style={{ fontSize: "11px" }}
                              >
                                {confirmer.phone}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ant-col ant-col-12 hp-text-sm-left hp-text-right ant-col-sm-6"
                          style={{ minHeight: "50px" }}
                        >
                          <span className="hp-d-block hp-p3-body hp-font-weight-400 hp-slashed-zero text-gray-800 dark:text-gray-200">
                            {t("Products.Table.confirmers.confirmedPrice")}:{" "}
                            <span className="fs-2-5 ">
                              {" "}
                              {confirmer.pricing?.confirmPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                          <span className="hp-d-block hp-p1-body hp-mt-4 hp-slashed-zero text-gray-700 dark:text-gray-400">
                            {t("Products.Table.confirmers.cancelledPrice")}:{" "}
                            <span className="fs-2-4 ">
                              {" "}
                              {confirmer.pricing?.cancelPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                        </div>
                        <div className="ant-col">
                          <a href={`tel:${confirmer.phone}`}>
                            <img
                              src="https://cdn-icons-png.flaticon.com/128/16620/16620482.png"
                              alt={t("workersManagement.table.user")}
                              style={{
                                maxWidth: "34px",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
            </ul>

            <ul className="grid gap-y-2 gap-x-6 flex-wrap mt-3">
              {confirmers.map((confirmer, idx) => {
                const isSkuInConfirmer = confirmer.products?.some(
                  (product) =>
                    Array.isArray(product.sku) &&
                    product.sku.some((sku) => sku === rowData.sku),
                );
                const isChecked = isSkuInConfirmer;

                return (
                  confirmer.deleted !== true &&
                  !isChecked && (
                    <div
                      className="ant-col ant-col-24 hp-border-radius-lx hp-border-1 border border-gray-200 dark:border-[#3c3a3d] dark:bg-[#1e1e1e]"
                      style={{ paddingLeft: "6px", paddingRight: "6px" }}
                      key={idx}
                    >
                      <div
                        className="ant-row ant-row-space-between ant-row-middle"
                        style={{ rowGap: "0px" }}
                      >
                        <div className="ant-col ant-col-24 hp-mb-sm-16 ant-col-sm-12">
                          <div
                            className="ant-row ant-row-no-wrap ant-row-middle"
                            style={{ rowGap: "0px" }}
                          >
                            <Checkbox
                              id={`confirmer-${idx}`}
                              type="checkbox"
                              className="checkbox-item peer hidden"
                              onChange={(e) =>
                                handleCheckboxChange(
                                  confirmer.user,
                                  e.target.checked,
                                )
                              }
                            />

                            <div className="ant-col">
                              <div
                                className="hp-border-radius-md hp-cursor-pointer hp-border-1 hp-mr-16 m-2 rounded-full border-gray-300 dark:border-[#3c3a3d]"
                                style={{
                                  maxHeight: "64px",
                                  maxWidth: "64px",
                                }}
                              >
                                <div className="hp-border-radius-in hp-overflow-hidden hp-m-4 hp-d-flex rounded-full">
                                  <img
                                    src={
                                      confirmer.image ||
                                      "https://randomuser.me/api/portraits/women/79.jpg"
                                    }
                                    alt={t("workersManagement.table.user")}
                                    style={{ height: "100%" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ant-col">
                              <span className="hp-d-block hp-p3-body hp-font-weight-700 text-gray-800 dark:text-gray-200">
                                {confirmer.name}
                              </span>
                              <span
                                className="hp-d-block hp-p1-body text-gray-700 dark:text-gray-400"
                                style={{ fontSize: "11px" }}
                              >
                                {confirmer.phone}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ant-col ant-col-12 hp-text-sm-left hp-text-right ant-col-sm-6"
                          style={{ minHeight: "50px" }}
                        >
                          <span className="hp-d-block hp-p3-body hp-font-weight-400 hp-slashed-zero text-gray-800 dark:text-gray-200">
                            {t("Products.Table.confirmers.confirmedPrice")}:{" "}
                            <span className="fs-2-5">
                              {confirmer.pricing?.confirmPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                          <span className="hp-d-block hp-p1-body hp-mt-4 hp-slashed-zero text-gray-700 dark:text-gray-400">
                            {t("Products.Table.confirmers.cancelledPrice")}:{" "}
                            <span className="fs-2-4">
                              {confirmer.pricing?.cancelPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                        </div>
                        <div className="ant-col">
                          <a href={`tel:${confirmer.phone}`}>
                            <img
                              src="https://cdn-icons-png.flaticon.com/128/16620/16620482.png"
                              alt={t("workersManagement.table.user")}
                              style={{
                                maxWidth: "34px",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
            </ul>
            <div className="p-4 border-t border-gray-200 dark:border-[#3c3a3d] mt-4 dark:bg-[#181919]">
              <div className="ant-col ant-col-24">
                <h3 className="text-gray-800 dark:text-gray-200">
                  {t("Products.Table.confirmers.settings")}
                </h3>
                <div className="hp-profile-notifications hp-mt-24">
                  {/* Switch 1 */}
                  <Row
                    className="ant-row-space-between ant-row-middle"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("Products.Table.confirmers.showToAll")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.isAll}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t(
                              "Products.Table.confirmers.changeStatusTitle",
                            ),
                            text: t(
                              "Products.Table.confirmers.changeStatusText",
                            ),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t(
                              "Products.Table.confirmers.changeStatusConfirm",
                            ),
                            cancelButtonText: t("common.no"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              toggleProductStatus(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>

                  {/* Switch 2 */}
                  <Row
                    className="ant-row-space-between ant-row-middle hp-mt-18"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("Products.Table.confirmers.allowEdit")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.editToOrders}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t(
                              "Products.Table.confirmers.changeStatusTitle",
                            ),
                            text: t(
                              "Products.Table.confirmers.changeStatusText",
                            ),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t(
                              "Products.Table.confirmers.changeStatusConfirm",
                            ),
                            cancelButtonText: t("common.no"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setEditOrders(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>

                  {/* Switch 3 */}
                  <Row
                    className="ant-row-space-between ant-row-middle hp-mt-18"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("Products.Table.confirmers.autoDelivery")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.upToDelivery}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t(
                              "Products.Table.confirmers.changeStatusTitle",
                            ),
                            text: t(
                              "Products.Table.confirmers.changeStatusText",
                            ),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t(
                              "Products.Table.confirmers.changeStatusConfirm",
                            ),
                            cancelButtonText: t("common.no"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setUptoDelivery(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>
                </div>
              </div>

              {/* Bouton Confirmer */}
              <div className="p-4 border-t border-gray-200 dark:border-[#3c3a3d] mt-4">
                <button
                  className="w-full px-4 py-2 text-white bg-[#9b59bf] hover:bg-[#8a4eaa] rounded-md focus:outline-none focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
                  onClick={handleAddProduct}
                >
                  {t("Products.Table.confirmers.confirmAction")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  const ProductButton = (product) => {
    const productKey = getProductSendKey(product);
    const isSending = sendingProductIds.has(productKey);
    const isAlreadySent = !!product?.ecommanageractive;

    return (
      <div className="relative inline-flex">
        <button
          onClick={() => handleSendProductToEcomanager(product)}
          disabled={isSending}
          className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] dark:!bg-[#181919] dark:!border-[#3c3a3d] transition-colors active:bg-[#faf1ff] disabled:opacity-60 disabled:cursor-not-allowed bot mx-auto"
        >
          {isSending ? (
            <svg
              className="animate-spin h-5 w-5 text-[#9e68ba]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            <img
              src="/ecomanger.png"
              style={{ width: "20px" }}
              alt={t("ui.buttonIcon")}
            />
          )}
        </button>
        {product?.ecommanageractive && (
          <span
            className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 border-2 border-white dark:border-[#181919] rounded-full"
            title={t("Products.Table.ecomanager.alreadyUploaded")}
          />
        )}
      </div>
    );
  };

  const imageBodyTemplate = (rowData) => {
    const isAiGenerated = rowData.created_via === "FoorAiProductPageGenerator";

    return (
      <div className="relative w-16 h-16">
        {rowData.image ? (
          <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm">
            <img
              src={rowData.image}
              onError={(e) => (e.target.src = "/product-foorweb.png")}
              alt={rowData.name || t("Products.Table.headers.product")}
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm flex items-center justify-center text-[#9e68ba]">
            <Tag size={24} />
          </div>
        )}

        {isAiGenerated && (
          <div
            className="absolute -top-1 -right-1 bg-gradient-to-r from-[#9b59bf] to-[#7e5395] text-white rounded-full px-1.5 py-0.5 flex items-center justify-center shadow-md"
            style={{ fontSize: "9px", lineHeight: "1" }}
            title={t("Products.Table.aiGenerated.title")}
          >
            <Sparkle size={9} className="ml-0.5" />
            <span>AI</span>
          </div>
        )}
      </div>
    );
  };
  const priceproduct = (rowData) => {
    return (
      <div className="flex items-center justify-start gap-2 text-gray-700">
        <span className="text-end font-medium" style={{ color: "#6e4881" }}>
          {rowData.price} {localizedCurrency}
        </span>
      </div>
    );
  };

  const visitspriproduct = (rowData) => {
    return (
      <div className="flex items-center justify-start gap-2 text-gray-700">
        <span className="text-end">{rowData.visits ? rowData.visits : 0}</span>
      </div>
    );
  };

  const viewpage = (rowData) => {
    return (
      <button
        className="flex items-center justify-center mx-auto"
        onClick={() => {
          if (!account.store) {
            message.error(t("Products.Table.noStore"));
            return;
          }

          let finalUrl = "";

          if (account.productMode === "digital") {
            const storeName = account?.store?.split(".")[0];
            const newDomain = `${storeName}.foorweb.online`;
            finalUrl = `${newDomain}/products/${rowData.url}`;
          } else {
            const baseUrl = account.store.replace(/\/+$/, "");

            const storeName = baseUrl.split("://")[1].split(".")[0];

            finalUrl = `${baseUrl}/${storeName}/products/${rowData.url}`;
          }

          window.open(finalUrl, "_blank", "noopener,noreferrer");
        }}
      >
        <img
          style={{ width: "32px", height: "32px" }}
          src="/vision.png"
          className="rounded-full"
          alt={t("Products.Table.headers.preview")}
        />
      </button>
    );
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="relative">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpenDropdownId(
              openDropdownId === rowData.id ? null : rowData.id,
            );
          }}
          className="p-2 rounded-full hover:bg-purple-100 transition-colors"
        >
          <MoreVertical
            size={18}
            className="text-[#9e68ba] dark:text-[#b57ed8]"
          />
        </button>
        <div
          className={`absolute mt-1 bg-white border border-[#fbf4ff] shadow-lg rounded-lg z-[200] w-[130px] ${
            openDropdownId === rowData.id ? "block" : "hidden"
          }`}
          style={{ pointerEvents: "auto" }}
        >
          <ul className="py-1">
            <li
              onClick={async (e) => {
                setOpenDropdownId(null);
                e.stopPropagation();
                if (!!account.store) {
                  if (
                    account?.productMode != "digital" ||
                    !account?.twoFAActivated
                  )
                    return handleUpdate(rowData);
                  const expired = await isOtpExpired();
                  if (expired) {
                    setPendingRowData(rowData);
                    setShowOtpModal(true);
                  } else {
                    handleUpdate(rowData);
                  }
                } else {
                  message();
                }

                setOpenDropdownId(null);
              }}
              className="px-3 py-2 hover:bg-[#faf1ff] cursor-pointer text-sm text-gray-700 flex items-center gap-2"
            >
              <Edit size={14} className="text-green-600" />
              <span>{t("Products.Table.Actions.edit")}</span>
            </li>

            <li
              onClick={(e) => {
                setOpenDropdownId(null);
                e.stopPropagation();

                if (account?.store) {
                  const baseUrl = account.store.replace(/\/+$/, "");

                  const finalUrl = `${baseUrl}/Landingpage/${rowData.url}`;

                  window.open(finalUrl, "_blank", "noopener,noreferrer");
                } else {
                  message();
                }

                setOpenDropdownId(null);
              }}
              className="px-3 py-2 hover:bg-[#faf1ff] cursor-pointer text-sm text-gray-700 flex items-center gap-2"
            >
              <Eye size={14} className="text-blue-600" />
              <span>{t("Products.Table.Actions.viewLanding")}</span>
            </li>

            <li
              onClick={(e) => {
                setOpenDropdownId(null);
                e.stopPropagation();
                if (!!account.store) {
                  handleDelete(rowData);
                } else {
                  message();
                }
                setOpenDropdownId(null);
              }}
              className="px-3 py-2 hover:bg-[#faf1ff] cursor-pointer text-sm text-gray-700 flex items-center gap-2"
            >
              <Trash size={14} className="text-red-600" />
              <span>{t("Products.Table.Actions.delete")}</span>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  const pageRows = filter
    ? orderedProducts.filter((product) => {
        const q = String(filter).toLowerCase();
        return (
          (product.name && product.name.toLowerCase().includes(q)) ||
          (product.sku && product.sku.toLowerCase().includes(q))
        );
      })
    : _DATA.currentData();

  const pageIds = pageRows.map((p) => p.id).filter(Boolean);

  // Render the new styled table
  return (
    <div className="bg-purple-50 dark:!bg-[#141414] col-span-1 md:col-span-2 rounded-xl shadow-md w-full border border-[#fbf4ff] dark:!border-[#3c3a3d]">
      <div className="p-6 flex flex-col h-full dark:!bg-[#181919]">
        <div className="flex items-center justify-between gap-3">
          <h5 className="font-bold text-lg text-gray-800 dark:text-gray-100 m-0 dark:!bg-[#181919] flex items-center">
            {t("Products.Table.title")}
          </h5>

          {store?.ecomangerActive && (
            <button
              onClick={handleSendAllToEcomanager}
              disabled={isSendingAllToEcomanager}
              className="px-4 py-2 text-white bg-[#9b59bf] hover:bg-[#8a4eaa] disabled:opacity-60 disabled:cursor-not-allowed rounded-md focus:outline-none focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            >
              {isSendingAllToEcomanager
                ? t("Products.Table.sendingAllToEcomanager")
                : t("Products.Table.sendAllToEcomanager")}
            </button>
          )}
        </div>

        <div className="w-full overflow-visible bg-white dark:!bg-[#181919] rounded-xl mt-4 shadow-sm">
          <div className="overflow-x-auto">
            <style>{darkModeStyles}</style>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragStart={handleDragStart}
              onDragEnd={handleDragEnd}
              onDragCancel={handleDragCancel}
            >
              <table
                dir={direction}
                className={`w-full ${
                  direction === "rtl" ? "text-right" : "text-left"
                }`}
              >
                <thead>
                  <tr className="bg-purple-100 dark:!bg-[#1e1e1e] ">
                    <th className="p-2 w-10" aria-label={t("ui.reorder")} />
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.product")}
                    </th>
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.name")}
                    </th>
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.sku")}
                    </th>
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.preview")}
                    </th>
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.quantity")}
                    </th>
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.price")}
                    </th>
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.visits")}
                    </th>
                    {store?.ecomangerActive &&
                      account.productMode !== "digital" && (
                        <th className="p-4 font-medium text-[#9e68ba]">
                          {t("Products.Table.headers.sendToEcomanager")}
                        </th>
                      )}
                    <th className="p-4 font-medium text-[#9e68ba] text-center">
                      {t("Products.Table.headers.status")}
                    </th>
                    <th className="w-8 p-4"></th>
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.actions")}
                    </th>
                    <th className="w-8 p-4"></th>
                  </tr>
                </thead>

                <tbody>
                  <SortableContext
                    items={pageIds}
                    strategy={verticalListSortingStrategy}
                  >
                    {pageRows.length > 0 ? (
                      pageRows.map((product, index) => (
                        <React.Fragment key={product.id || index}>
                          <SortableProductRow
                            product={product}
                            disabled={!canReorder}
                          >
                            <td className="p-4">
                              {imageBodyTemplate(product)}
                            </td>
                            <td
                              className="p-4 font-medium text-gray-800 dark:text-gray-200"
                              style={{ maxWidth: "250px" }}
                            >
                              {truncateName(product.name, 25)}
                            </td>
                            <td className="p-4 text-gray-700 dark:text-gray-300">
                              {product.sku}
                            </td>
                            <td className="p-4">{viewpage(product)}</td>
                            <td className="p-4 text-gray-700 dark:text-gray-300">
                              {product.qty || 0}
                            </td>
                            <td className="p-4">{priceproduct(product)}</td>
                            <td className="p-4">{visitspriproduct(product)}</td>

                            {store?.ecomangerActive &&
                              account.productMode !== "digital" && (
                                <td className="p-4">
                                  {ProductButton(product)}
                                </td>
                              )}

                            <td className="p-4 text-center">
                              {paidBodyTemplate(product)}
                            </td>
                            <td className="p-4">{actionTemplate(product)}</td>
                            <td className="p-4">
                              <button
                                type="button"
                                onClick={() => toggleRow(product.id)}
                                className="p-2 rounded-full hover:bg-[#faf1ff] dark:hover:bg-[#2a2a2a] transition-colors"
                              >
                                {expandedRows[product.id] ? (
                                  <ChevronUp
                                    size={18}
                                    className="text-[#9e68ba]"
                                  />
                                ) : (
                                  <ChevronDown
                                    size={18}
                                    className="text-[#9e68ba]"
                                  />
                                )}
                              </button>
                            </td>
                          </SortableProductRow>

                          {expandedRows[product.id] && (
                            <tr className="bg-[#fcf6ff] dark:bg-[#1a1a1a]">
                              <td
                                colSpan={store?.ecomangerActive ? 12 : 11}
                                className="p-0"
                              >
                                <div className="h-fit overflow-y-auto">
                                  <div className="p-6 rounded-xl bg-white dark:!bg-[#181919] border border-[#fbf4ff] dark:!border-[#3c3a3d] shadow-md m-4">
                                    <h4
                                      className={`text-lg font-medium dark:!bg-[#181919] mb-4 text-[#9e68ba] dark:text-[#b57ed8] border-b border-[#fbf4ff] dark:border-[#3c3a3d] pb-2 sticky top-0 bg-white z-10 ${
                                        direction === "rtl"
                                          ? "text-right"
                                          : "text-left"
                                      }`}
                                    >
                                      {t("Products.Table.expand.title")}
                                    </h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 dark:!border-[#3c3a3d]">
                                      {[
                                        {
                                          title:
                                            "Products.Table.expand.info.title",
                                          content: (
                                            <>
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.info.name",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {product.name}
                                              </span>
                                              <br />
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.info.sku",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {product.sku}
                                              </span>
                                              <br />
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.info.quantity",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {product.qty || 0}
                                              </span>
                                              <br />
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.info.price",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {product.price}{" "}
                                                {localizedCurrency}
                                              </span>
                                            </>
                                          ),
                                        },
                                        {
                                          title:
                                            "Products.Table.expand.category.title",
                                          content: (
                                            <>
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.category.category",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {product.category_id ||
                                                  t(
                                                    "Products.Table.expand.default.noCategory",
                                                  )}
                                              </span>
                                              <br />
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.category.rating",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {product.review || 0}{" "}
                                                {t(
                                                  "Products.Table.expand.default.stars",
                                                )}
                                              </span>
                                              <br />
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.category.visits",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {product.visits || 0}
                                              </span>
                                              <br />
                                              <span className="font-medium text-gray-800 dark:text-gray-200">
                                                {t(
                                                  "Products.Table.expand.category.shipping",
                                                )}
                                              </span>
                                              <span className="text-gray-700 dark:text-gray-300">
                                                {t(
                                                  "Products.Table.expand.default.available",
                                                )}
                                              </span>
                                            </>
                                          ),
                                        },
                                        {
                                          title:
                                            "Products.Table.expand.notes.title",
                                          content: (
                                            <span className="text-gray-700 dark:text-gray-300">
                                              {product.comment ||
                                                t(
                                                  "Products.Table.expand.default.noNotes",
                                                )}
                                            </span>
                                          ),
                                        },
                                      ].map((section, i) => (
                                        <div
                                          key={i}
                                          className="bg-[#fcf6ff] dark:bg-[#1e1e1e] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]"
                                        >
                                          <h5
                                            className={`text-sm font-medium text-[#9e68ba] dark:text-[#b57ed8] mb-2 ${
                                              direction === "rtl"
                                                ? "text-right"
                                                : "text-left"
                                            }`}
                                          >
                                            {t(section.title)}
                                          </h5>
                                          <div
                                            className={`text-gray-700 dark:text-gray-300 ${
                                              direction === "rtl"
                                                ? "text-right"
                                                : "text-left"
                                            }`}
                                          >
                                            {section.content}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={store?.ecomangerActive ? 12 : 11}
                          className="p-8 text-center text-gray-500 dark:text-gray-400"
                        >
                          {t("Products.Table.empty")}
                        </td>
                      </tr>
                    )}
                  </SortableContext>
                </tbody>
              </table>
            </DndContext>
          </div>
        </div>
        {showOtpModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-md w-96 shadow-lg">
              <h2 className="text-lg font-semibold mb-4 text-center text-gray-700">
                {t("Products.Table.otp.title")}
              </h2>
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                maxLength={6}
                className="w-full border border-gray-300 rounded-md px-4 py-2 mb-4 text-center text-lg tracking-widest"
                placeholder="______"
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowOtpModal(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                >
                  {t("Products.Table.otp.cancel")}
                </button>
                <button
                  onClick={handleVerifyCode}
                  className="px-4 py-2 bg-[#7e5395] text-white rounded-md"
                >
                  {t("Products.Table.otp.verify")}
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          className={`flex justify-center py-3 bg-white dark:!bg-[#181919] mt-4 rounded-xl direction-rtl `}
        >
          <Stack spacing={2} dir="ltr">
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000",
                  borderColor: isDark ? "#a065c0" : "#ccc",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                },
              }}
            />
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
